<script>
    import { getContext } from 'svelte';
    import Sort from "./Sort.svelte";
    import {getRouteById} from "../Nav";
    import {strToLocaleDateTime, UserStatus, UserType} from "../Utils";
    import AddContactAsUserButton from "./AddContactAsUserButton.svelte";

    export let message;
    export let contacts;
    export let users;

    export let onOkay = () => {};
    const { close } = getContext('simple-modal');

    function _onOkay() {
        onOkay();
        close();
    }
</script>

<h4 class="text-center mb-3">{message}</h4>
<div class="row mb-3">
    <table class="table table-bordered table-sm">
        <thead class="position-sticky bg-white shadow">
        <tr style="font-size: 14px;">
            <th rowspan="2" style="min-width: 70px">ID</th>
            <th rowspan="2" style="min-width: 120px">Ім'я</th>
            <th rowspan="2">Телефон</th>
            <th rowspan="2">Telegram ID</th>
            <th colspan="9">Контакт</th>
            <th rowspan="9" style="min-width: 100px">Створений</th>
            <th rowspan="2"></th>
        </tr>
        <tr style="font-size: 14px;">
            <th style="min-width: 75px">ПІБ</th>
            <th>Telegram ID</th>
            <th>Телефон</th>
            <th>Username</th>
            <th>Контакт</th>
            <th>Взаємний контакт</th>
            <th>Тип</th>
            <th>Статус</th>
            <th>Був онлайн</th>
        </tr>
        </thead>
        <tbody>
        {#if contacts.length > 0}
            {#each contacts as contact}
                <tr>
                    <td rowspan="1">{contact.id}</td>
                    {#if contact.telegram_user_id in users}
                        <td rowspan="1">{users[contact.telegram_user_id].names.length > 0 ?
                            users[contact.telegram_user_id].names.map((item) => item.name).join(', ') :
                            '-'
                        }</td>
                        <td rowspan="1">{users[contact.telegram_user_id].phone}</td>
                    {:else }
                        <td rowspan="1">-</td>
                        <td rowspan="1">-</td>
                    {/if}
                    <td rowspan="1">{contact.telegram_user_id ?? ''}</td>
                    <td>{contact.first_name ?? ''} {contact.last_name ?? ''}</td>
                    <td>{contact.telegram_contact_id ?? ''}</td>
                    <td class:ua={(contact.phone ?? '').indexOf('38')===0}>
                        {contact.phone ?? ''}
                    </td>
                    <td>{contact.username ?? ''}</td>
                    <td>
                        {#if contact.is_contact == true}
                            <i class="bi bi-check text-success"></i>
                        {:else }
                            <i class="bi bi-x text-danger"></i>
                        {/if}
                    </td>
                    <td>
                        {#if contact.is_mutual_contact == true}
                            <i class="bi bi-check text-success"></i>
                        {:else }
                            <i class="bi bi-x text-danger"></i>
                        {/if}
                    </td>
                    <td>{UserType[contact.type] ?? 'без типу'}</td>
                    <td>{UserStatus[contact.status] ?? 'без типу'}</td>
                    <td>{contact.was_online ? strToLocaleDateTime(contact.was_online) : ''}</td>
                    <td>{contact.created_at ? strToLocaleDateTime(contact.created_at): ''}</td>
                    <td><AddContactAsUserButton {contact}/></td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                    <div class="alert alert-secondary">Немає контактів</div>
                </td>
            </tr>
        {/if}
        </tbody>
    </table>
</div>
<div class="buttons">
</div>